var map = {
	"./serifnew_box00.jpg": "fd5e",
	"./serifnew_box01.jpg": "6f16",
	"./serifnew_box02.jpg": "0dda",
	"./serifnew_box03.jpg": "e30c",
	"./serifnew_box04.jpg": "3b34",
	"./serifnew_box05.jpg": "a453",
	"./serifnew_box06.jpg": "75bd",
	"./serifnew_box07.jpg": "9337",
	"./serifnew_box08.jpg": "dbd2",
	"./serifnew_box09.jpg": "6539",
	"./serifnew_box10.jpg": "d23a",
	"./serifnew_box11.jpg": "7dbf",
	"./serifnew_box12.jpg": "129b",
	"./serifnew_box13.jpg": "fcdd",
	"./serifnew_box14.jpg": "3748",
	"./serifnew_box15.jpg": "70b5",
	"./serifnew_box16.jpg": "71c7",
	"./serifnew_box17.jpg": "7feb",
	"./serifnew_box18.jpg": "23d8",
	"./serifnew_box19.jpg": "ea8e",
	"./serifnew_box20.jpg": "8cba",
	"./serifnew_box21.jpg": "bb21",
	"./serifnew_box22.jpg": "2b7b",
	"./serifnew_box23.jpg": "44b2",
	"./serifnew_box24.jpg": "817e",
	"./serifnew_box25.jpg": "07f2",
	"./serifnew_box26.jpg": "4d43",
	"./serifnew_box27.jpg": "d481",
	"./serifnew_box28.jpg": "1ae5",
	"./serifnew_box29.jpg": "0e14",
	"./serifnew_box30.jpg": "ecf6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b6f4";